module.exports = __webpack_public_path__ + "static/media/card.410dacd4.png";